import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=a5f995a8&"
import script from "./Platform.vue?vue&type=script&lang=ts&"
export * from "./Platform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports